import { render, staticRenderFns } from "./use-getpsc.vue?vue&type=template&id=1545f277&"
import script from "./use-getpsc.vue?vue&type=script&lang=js&"
export * from "./use-getpsc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports